import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddmemberComponent } from './components/addmember/addmember.component';
import { ViewmemberComponent } from './components/viewmember/viewmember.component';
import { MembershipInitiatedComponent } from './components/membership-initiated/membership-initiated.component';
import { EcardComponent } from './components/ecard/ecard.component';
import { RedirectComponent } from './components/redirect/redirect.component';
import { SendsmsComponent } from './components/sendsms/sendsms.component';
import { AuthserviceComponent } from './components/authservice/authservice.component';
import { TrackappComponent } from './components/trackapp/trackapp.component';
import { ApkinstallerComponent } from './components/apkinstaller/apkinstaller.component';
import { FaqComponent } from './components/faq/faq.component';
import { TermConditionComponent } from './components/term-condition/term-condition.component';
import { DigitalDeclarationComponent } from './components/digitaldeclaration/digitaldeclaration.component';


const routes: Routes = [
 {path: '', component: TrackappComponent},
 {path: 'membership/:memberId', component: TrackappComponent},
  {path: 'newmember', component: AddmemberComponent},
  {path: 'viewmember/:memberId', component: ViewmemberComponent},
  {path: 'viewmember/qc/:mamemberId', component: ViewmemberComponent},
  {path: 'addmember/new', component: AddmemberComponent},
  {path: 'addmember/new/:memberId', component: AddmemberComponent},
  {path: 'onhold/:mamemberId', component: ViewmemberComponent},
  {path: 'redirect', component: RedirectComponent},
  {path: 'downloadEcard/:memberId/:cardId', component: SendsmsComponent},
  {path: 'authservice/mobileapp', component: AuthserviceComponent},
  {path: 'app-initiated', component: MembershipInitiatedComponent},
  {path: 'app', component: TrackappComponent},
  {path: 'E-card', component: EcardComponent},  
  {path: 'installer', component: ApkinstallerComponent},
  {path: 'faq', component: FaqComponent},
  {path: 'tc', component: TermConditionComponent},
  {path: 'dec', component: DigitalDeclarationComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
